import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	container: {
		paddingTop: theme.spacing(3),
		paddingBottom: theme.spacing(5)
	},
	title: {
		paddingBottom: theme.spacing(1)
	}
}));
